import { Grid, Paper, Typography } from "@mui/material";
import { Cart } from "@t3/shared";

export const CartBalanceSheet = ({ cartData }: { cartData: Cart }) => {
  // Calculate total cost from items
  let totalPointsCost = 0;
  let totalPointsRefunded = 0;

  if (cartData.purchaseResults?.tangoPurchaseResults) {
    Object.values(cartData.purchaseResults.tangoPurchaseResults).forEach(
      (productArray) => {
        productArray.forEach((product) => {
          // Only add to total cost if the item is not refunded
          if (product.status === "completed") {
            totalPointsCost += product.pointsCost;
          } else if (
            product.status === "refund" ||
            product.status === "refunded"
          ) {
            // Track refunded points separately
            totalPointsRefunded += product.pointsRefunded;
          }
        });
      },
    );
  }

  if (cartData.purchaseResults?.travelPurchaseResults) {
    Object.values(cartData.purchaseResults.travelPurchaseResults).forEach(
      (productArray) => {
        productArray.forEach((product) => {
          // Only add to total cost if the item is not refunded
          if (product.status === "completed") {
            totalPointsCost += product.pointsCost;
          } else if (
            product.status === "refund" ||
            product.status === "refunded"
          ) {
            // Track refunded points separately
            totalPointsRefunded += product.pointsRefunded;
          }
        });
      },
    );
  }

  if (cartData.purchaseResults?.zincPurchaseResults) {
    cartData.purchaseResults.zincPurchaseResults.forEach((product) => {
      // Only add to total cost if the item is not refunded
      if (product.status === "completed") {
        totalPointsCost += product.pointsCost;
      } else if (product.status === "refund" || product.status === "refunded") {
        // Track refunded points separately
        totalPointsRefunded += product.pointsRefunded;
      }
    });
  }

  return (
    <Grid container justifyContent="flex-end" data-cypress="cart-balance-sheet">
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
        <Paper
          elevation={2}
          sx={{ my: 2, p: 1.5, borderRadius: 1.5, bgcolor: "#f9f9f9" }}
          data-cypress="balance-sheet-paper"
        >
          <Grid container spacing={1}>
            <Grid size={6}>
              <Typography variant="body2" data-cypress="total-cost-label">
                Total Cost:
              </Typography>
            </Grid>
            <Grid size={6} sx={{ textAlign: "right", color: "red" }}>
              <Typography variant="body2" data-cypress="total-cost-value">
                {totalPointsCost} points
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};
